if (!customElements.get('product-info-modal-carousel')) {
  customElements.define(
    'product-info-modal-carousel',
    class ProductInfoModalCarousel extends HTMLElement {
      constructor() {
        super();

        this.childElements = [...this.children];
        this.childElements.forEach((child) => {
          child.classList.add('splide__slide');
        });
        this.slides = this.innerHTML;

        this.generateCarousel = this.generateCarousel.bind(this);
      }

      connectedCallback() {
        this.generateCarousel();
      }

      generateCarousel() {
        this.innerHTML = '';

        const mainSlider = document.createElement('div');
        mainSlider.classList.add('splide', 'relative', 'product-info-carousel');
        const list = document.createElement('div');
        const track = document.createElement('div');
        list.classList.add('splide__list');
        track.classList.add('splide__track');
        list.innerHTML = this.slides;
        track.append(list);
        mainSlider.append(track);
        this.append(mainSlider);

        // Only show arrows if there are multiple images
        const shouldShowArrows = this.childElements.length > 1;

        const main = new window.Splide(mainSlider, {
          arrows: shouldShowArrows,
          pagination: false,
          perPage: 1,
          drag: false,
          // Add rewind to ensure carousel loops
          rewind: true,
          arrowPath:
            'M31 20.5 10.85 40 8 37.242 25.3 20.5 8 3.758 10.85 1l17.3 16.742L31 20.5Z',
          classes: {
            arrows: 'splide__arrows',
            arrow:
              'splide__arrow h-10 w-10 rounded-none opacity-100 !bg-transparent !border-none',
            prev: 'splide__arrow--prev absolute !left-2 z-10',
            next: 'splide__arrow--next absolute !right-2 z-10'
          }
        });

        main.mount();

        // Force arrows to be visible if there are multiple images
        // This overrides the .splide:not(.is-overflow) .splide__arrows { display: none; } rule
        if (shouldShowArrows) {
          // Use a small delay to ensure Splide has fully initialized
          setTimeout(() => {
            const arrowsElement = mainSlider.querySelector('.splide__arrows');
            if (arrowsElement) {
              arrowsElement.style.display = 'flex';
              arrowsElement.style.visibility = 'visible';
            }
          }, 50);
        }
      }
    }
  );
}
